import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { rolesApi } from 'components/Authorize/rolesSlice';
import genericTableStateSlice from 'components/DataTable/genericTableStateSlice';
import { userPreferencesApi } from 'components/UserPreferences/userPreferencesSlice';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { customReportApi } from 'features/Forms/CustomReport/customReportSlice';
import formStateReducer from 'features/Forms/FormList/formStateSlice';
import { formBuilderApi } from 'features/Forms/formBuilder/formBuilderSlice';
import issuesTrackerFiltersReducer from 'features/IssuesTracker/issuesTrackerFiltersSlice';
import { issuesTrackerApi } from "features/IssuesTracker/issuesTrackerSlice";
import { mobileActivityApi, mobileActivitySlice } from 'features/MobileActivity/mobileActivitySlice';
import { reservationApi } from 'features/Reservation/reservationSlice';
import reservationsFiltersSlice from 'features/Reservation/reservationsFiltersSlice';
import { userTaskApi } from 'features/Tasks/components/UserTasks/userTaskSlice';
import { taskApi, taskStateSlice } from 'features/Tasks/taskSlice';
import { cameraEventsApi } from 'features/access/CamerEvents/cameraEventSlice';
import cameraEventsReducer from 'features/access/CamerEvents/cameraEventsStateSlice';
import { doorReleaseApi } from 'features/access/DoorRelease/doorReleaseSlice';
import doorReleaseReducer from 'features/access/DoorRelease/doorReleaseStateSlice';
import { accessApi } from "features/access/accessSlice";
import accessStateReducer from 'features/access/accessStateSlice';
import { activityTypeInventoryApi } from 'features/activity/ActivityTypeInventorySlice';
import { activityTypeStepApi } from 'features/activity/ActivityTypeStepSlice';
import activityReportFiltersReducer from 'features/activity/activityReportFiltersSlice';
import { activityApi } from "features/activity/activitySlice";
import addAssetReducer from 'features/addAsset/addAssetSlice';
import { carrierFiltersSlice } from 'features/carriers/carrierFiltersSlice';
import { carrierApi } from "features/carriers/carrierSlice";
import { clientAccountApi } from 'features/clients/clientAccountSlice';
import { clientConfigApi } from 'features/clients/clientConfigSlice';
import { lotConfigApi, lotConfigSlice } from 'features/clients/clientConfigs/lots/lotConfigSlice';
import { washSlaSlice } from 'features/clients/clientConfigs/washes/WashSlaSlice';
import { washProgramApi } from 'features/clients/clientConfigs/washes/washProgramSlice';
import { clientApi } from "features/clients/clientSlice";
import { mobileWorkflowSlice, workflowApi } from 'features/clients/contracts/EditContractPopup/EditWorkFlowPopup/workFlowSlice';
import { issueTrackerRuleApi } from 'features/clients/contracts/IssueTrackerConfig/IssueTrackerRuleSlice';
import { mechanicalsApi } from 'features/clients/contracts/MechanicalWorkConfig/mechanicalsSlice';
import { driverApi } from 'features/drivers/driversSlice';
import { flagsApi } from 'features/flag/flagsSlice';
import inventoryFiltersReducer from 'features/inventory/inventoryFiltersSlice';
import { activityInvoiceStateSlice } from 'features/invoice/activity/activityInvoiceSlice';
import { loadInvoiceApi, loadInvoiceStateSlice } from 'features/invoice/loads/loadInvoiceSlice';
import { reportsApi } from 'features/invoice/reports/ReportsSlice';
import reportsFilterReducer from 'features/invoice/reports/reportsPage/reportsFilterSlice';
import { quickBooksAccountMappingApi, quickBooksMappingFiltersSlice } from 'features/invoice/shared/QuickBooksAccountMapping/QuickBooksAccountMappingSlice';
import { storageInvoiceApi, storageInvoiceStateSlice } from 'features/invoice/storage/storageInvoiceSlice.ts';
import { vendorInvoiceApi } from 'features/invoice/vendor/vendorInvoiceSlice';
import vendorInvoiceFiltersReducer from 'features/invoice/vendor/vendorInvoiceFiltersSlice';
import { billingApi, billingDashboardSlice } from 'features/landing/components/BillingDashboard/billingSlice';
import { fleetManagementDashboardSlice } from 'features/landing/components/FleetManagementDashboard/fleetManagementDashboardSlice';
import { inspectionSlice } from 'features/landing/components/KpiDashboard/navigations/KpiInspection/inspectionSlice';
import OneOnOneFiltersReducer from 'features/landing/components/KpiDashboard/navigations/KpiOneOnOne/OneOnOneFilterSlice';
import { oneOnOneApi } from 'features/landing/components/KpiDashboard/navigations/KpiOneOnOne/OneOnOneSlice';
import { washDashboardSlice } from 'features/landing/components/NewWashDashboard/washDashboardSlice';
import pendingWashesFiltersReducer from 'features/landing/components/WashDashboard/PendingWashCard/SlaTable/pendingWashesFiltersSlice';
import slaTableFiltersReducer from 'features/landing/components/WashDashboard/SlaChartCard/SlaTable/slaTableFiltersSlice';
import assetsFiltersSlice from 'features/landing/components/WorkorderDashboard/CreateWorkOrder/Assets/assetsFiltersSlice.js';
import { workorderDashboardSlice } from 'features/landing/components/WorkorderDashboard/workorderDashboardSlice';
import { dashboardSlice } from 'features/landing/dashboardSlice';
import { loadsDashboardSlice } from 'features/loads/components/LoadsDashboard/loadsDashboardSlice';
import loadGroupViewReducer from 'features/loads/loadGroupViewSlice';
import loadFiltersReducer from 'features/loads/loadsFiltersSlice';
import { loadApi } from 'features/loads/loadsSlice';
import loadStateReducer from 'features/loads/loadsStateSlice';
import { submarketApi } from 'features/lots/components/LotSubMarketsPage/lotSubMarketsSlice';
import { lotsCapacityFiltersSlice } from 'features/lots/components/LotsPage/LotsCapacity/LotsCapacityFiltersSlice';
import { lotApi, subMarketsSlice } from 'features/lots/lotSlice';
import { meApi } from 'features/me/meSlice';
import { mechanicalTaskSlice } from 'features/mechanicalTasks/slice';
import { notesApi } from 'features/notes/notesSlice';
import activityTypeFiltersSlice from 'features/pricing/ActivityTypesList/activityTypeFiltersSlice';
import activityPricingFiltersSlice from 'features/pricing/PricingList/activityPricingFiltersSlice';
import { activityTypePriceApi } from 'features/pricing/pricingSlice';
import { subscriptionApi } from 'features/subscriptions/subscriptionSlice';
import { taxRatesApi } from 'features/taxRate/TaxRateSlice';
import taxRatesFiltersReducer from 'features/taxRate/taxRateFilterSlice';
import { transporterApi } from "features/transporter/transporterSlice";
import seamlessTokenReducer from 'features/user/seamlessTokenSlice';
import userReducer from 'features/user/userSlice';
import usersTableFiltersReducer from 'features/users/UserManagement/UsersTable/usersTableFiltersSlice';
import { permissionApi } from "features/users/UserManagement/permissionSlice";
import { userManagementApi } from "features/users/UserManagement/userManagementSlice";
import { userTaskConfigApi } from 'features/users/components/editUser/UserTasks/userTaskConfigSlice';
import usersFiltersReducer from 'features/users/usersFiltersSlice';
import { usersApi } from 'features/users/usersSlice';
import { reportApi } from "features/vehicles/Reports/reportSlice";
import { customFormResponseApi } from 'features/vehicles/VehicleCustomForm/CustomFormResponseSlice';
import auditFiltersSlice from 'features/vehicles/VehicleLotAudit/auditFiltersSlice';
import auditListFiltersSlice from 'features/vehicles/VehicleLotAudit/components/AuditList/auditListFiltersSlice';
import { vehicleStatusApi } from 'features/vehicles/VehicleStatus/vehicleStatusSlice';
import { configurationApi } from "features/vehicles/configurationSlice";
import { readinessApi } from 'features/vehicles/readiness/readinessSlice';
import { vehicleAttachmentsApi } from 'features/vehicles/vehicleAttachmentsSlice';
import vehicleFiltersReducer from 'features/vehicles/vehicleFiltersSlice';
import { vehicleApi } from "features/vehicles/vehicleSlice";
import { vendorApi } from 'features/vendor/vendorSlice';
import dashboardFiltersReducer from 'features/vms/vendorDashboard/dashboardFiltersSlice';
import { vendorContactApi } from 'features/vms/vendorDirectory/vendorContact/vendorContactSlice';
import { vendorFiltersSlice } from 'features/vms/vendorDirectory/vendorFiltersSlice';
import { createBrowserHistory } from "history";
import { confirmationApi } from '../../components/ExternalConfirmation/confirmationSlice';
import { contactTypeApi } from "../../features/contactType/contactTypeSlice";
import { securityPhotosApi } from "../../features/lots/components/SecurityPhotos/SecurityPhotosSlice";
import { tenantApi } from '../../features/saasManagement/tenantSlice';
import { roleApi } from "../../features/users/UserManagement/roleSlice";
import { vendorFeedbackApi } from '../../features/vms/vendorFeedback/vendorFeedbackSlice';
import { vmsApi } from '../../features/vms/vmsSlice';
import { rtkQueryErrorLogger } from '../errorHandling';
import { quickBooksMappingApi } from 'features/invoice/shared/QuickBooksMapping/QuickBooksMappingSlice';

export const history = createBrowserHistory();

let store = configureStore({
    reducer: {
        user: userReducer,
        seamlessToken: seamlessTokenReducer,
        usersFilters: usersFiltersReducer,
        vehicleFilters: vehicleFiltersReducer,
        usersTableFilters: usersTableFiltersReducer,
        slaTableFilters: slaTableFiltersReducer,
        pendingWashesFilters: pendingWashesFiltersReducer,
        oneOnOneFilters: OneOnOneFiltersReducer,
        loadFilters: loadFiltersReducer,
        vendorInvoiceFilters: vendorInvoiceFiltersReducer,
        loadState: loadStateReducer,
        loadGroupViewState: loadGroupViewReducer,
        accessState: accessStateReducer,
        formState: formStateReducer,
        doorReleaseState: doorReleaseReducer,
        cameraEventsState: cameraEventsReducer,
        auditFilters: auditFiltersSlice,
        auditListFilters: auditListFiltersSlice,
        activityReportFilters: activityReportFiltersReducer,
        activityTypeFilters: activityTypeFiltersSlice,
        activityPricingFilters: activityPricingFiltersSlice,
        assetsFilters: assetsFiltersSlice,
        addAsset: addAssetReducer,
        taskState: taskStateSlice.reducer,
        subMarketsState: subMarketsSlice.reducer,
        dashboardState: dashboardSlice.reducer,
        inspectionState: inspectionSlice.reducer,
        loadInvoiceState: loadInvoiceStateSlice.reducer,
        storageInvoiceState: storageInvoiceStateSlice.reducer,
        activityInvoiceState: activityInvoiceStateSlice.reducer,
        mobileWorkflowState: mobileWorkflowSlice.reducer,
        lotConfigState: lotConfigSlice.reducer,
        billingDashboardState: billingDashboardSlice.reducer,
        workorderDashboardState: workorderDashboardSlice.reducer,
        fleetManagementDashboardState: fleetManagementDashboardSlice.reducer,
        loadsDashboardState: loadsDashboardSlice.reducer,
        washDashboardState: washDashboardSlice.reducer,
        mobileActivityState: mobileActivitySlice.reducer,
        washConfigState: washSlaSlice.reducer,
        mechanicalTaskSlice: mechanicalTaskSlice.reducer,
        configurationApiSlice: configurationApi.reducer,
        reportApiSlice: reportApi.reducer,
        inventoryFilters: inventoryFiltersReducer,
        issuesTrackerFilters: issuesTrackerFiltersReducer,
        reservationsFilters: reservationsFiltersSlice,
        genericTableState: genericTableStateSlice,
        reportsFilter: reportsFilterReducer,
        taxRatesFilters: taxRatesFiltersReducer,
        carrierFilters: carrierFiltersSlice.reducer,
        quickBooksMappingFilters: quickBooksMappingFiltersSlice.reducer,
        lotsCapacityFilters: lotsCapacityFiltersSlice.reducer,
        vendorFilters: vendorFiltersSlice.reducer,
        dashboardFilters: dashboardFiltersReducer,
        [tenantApi.reducerPath]: tenantApi.reducer,
        [userManagementApi.reducerPath]: userManagementApi.reducer,
        [permissionApi.reducerPath]: permissionApi.reducer,
        [vehicleApi.reducerPath]: vehicleApi.reducer,
        [configurationApi.reducerPath]: configurationApi.reducer,
        [lotApi.reducerPath]: lotApi.reducer,
        [loadApi.reducerPath]: loadApi.reducer,
        [clientApi.reducerPath]: clientApi.reducer,
        [clientConfigApi.reducerPath]: clientConfigApi.reducer,
        [lotConfigApi.reducerPath]: lotConfigApi.reducer,
        [accessApi.reducerPath]: accessApi.reducer,
        [doorReleaseApi.reducerPath]: doorReleaseApi.reducer,
        [cameraEventsApi.reducerPath]: cameraEventsApi.reducer,
        [carrierApi.reducerPath]: carrierApi.reducer,
        [driverApi.reducerPath]: driverApi.reducer,
        [activityApi.reducerPath]: activityApi.reducer,
        [transporterApi.reducerPath]: transporterApi.reducer,
        [subscriptionApi.reducerPath]: subscriptionApi.reducer,
        [confirmationApi.reducerPath]: loadApi.reducer,
        [meApi.reducerPath]: loadApi.reducer,
        [readinessApi.reducerPath]: readinessApi.reducer,
        [taskApi.reducerPath]: taskApi.reducer,
        [workflowApi.reducerPath]: workflowApi.reducer,
        [loadInvoiceApi.reducerPath]: loadInvoiceApi.reducer,
        [storageInvoiceApi.reducerPath]: loadInvoiceApi.reducer,
        [submarketApi.reducerPath]: submarketApi.reducer,
        [usersApi.reducerPath]: usersApi.reducer,
        [userTaskApi.reducerPath]: userTaskApi.reducer,
        [userTaskConfigApi.reducerPath]: userTaskConfigApi.reducer,
        [userPreferencesApi.reducerPath]: userPreferencesApi.reducer,
        [oneOnOneApi.reducerPath]: oneOnOneApi.reducer,
        [issuesTrackerApi.reducerPath]: issuesTrackerApi.reducer,
        [mechanicalsApi.reducerPath]: mechanicalsApi.reducer,
        [billingApi.reducerPath]: billingApi.reducer,
        [mobileActivityApi.reducerPath]: mobileActivityApi.reducer,
        [notesApi.reducerPath]: notesApi.reducer,
        [flagsApi.reducerPath]: flagsApi.reducer,
        [activityTypePriceApi.reducerPath]: activityTypePriceApi.reducer,
        [vendorApi.reducerPath]: vendorApi.reducer,
        [activityTypeInventoryApi.reducerPath]: activityTypeInventoryApi.reducer,
        [activityTypeStepApi.reducerPath]: activityTypeStepApi.reducer,
        [reportApi.reducerPath]: readinessApi.reducer,
        [securityPhotosApi.reducerPath]: securityPhotosApi.reducer,
        [formBuilderApi.reducerPath]: formBuilderApi.reducer,
        [customReportApi.reducerPath]: customReportApi.reducer,
        [rolesApi.reducerPath]: rolesApi.reducer,
        [roleApi.reducerPath]: roleApi.reducer,
        [clientAccountApi.reducerPath]: clientAccountApi.reducer,
        [contactTypeApi.reducerPath]: contactTypeApi.reducer,
        [vehicleStatusApi.reducerPath]: vehicleStatusApi.reducer,
        [reportsApi.reducerPath]: reportsApi.reducer,
        [taxRatesApi.reducerPath]: taxRatesApi.reducer,
        [reservationApi.reducerPath]: reservationApi.reducer,
        router: connectRouter(history),
        [vehicleAttachmentsApi.reducerPath]: vehicleAttachmentsApi.reducer,
        [quickBooksAccountMappingApi.reducerPath]: quickBooksAccountMappingApi.reducer,
        [quickBooksMappingApi.reducerPath]: quickBooksMappingApi.reducer,
        [issueTrackerRuleApi.reducerPath]: issueTrackerRuleApi.reducer,
        [customFormResponseApi.reducerPath]: customFormResponseApi.reducer,
        [vendorFeedbackApi.reducerPath]: vendorFeedbackApi.reducer,
        [vendorContactApi.reducerPath]: vendorContactApi.reducer,
        [vmsApi.reducerPath]: vmsApi.reducer,
        [washProgramApi.reducerPath]: washProgramApi.reducer,
        [vendorInvoiceApi.reducerPath]: vendorInvoiceApi.reducer
    },
    middleware: getDefaultMiddleware({ serializableCheck: false })
        .concat(tenantApi.middleware)
        .concat(userManagementApi.middleware)
        .concat(permissionApi.middleware)
        .concat(roleApi.middleware)
        .concat(vehicleApi.middleware)
        .concat(configurationApi.middleware)
        .concat(lotApi.middleware)
        .concat(submarketApi.middleware)
        .concat(usersApi.middleware)
        .concat(userTaskApi.middleware)
        .concat(userTaskConfigApi.middleware)
        .concat(oneOnOneApi.middleware)
        .concat(clientApi.middleware)
        .concat(clientConfigApi.middleware)
        .concat(lotConfigApi.middleware)
        .concat(accessApi.middleware)
        .concat(doorReleaseApi.middleware)
        .concat(cameraEventsApi.middleware)
        .concat(carrierApi.middleware)
        .concat(driverApi.middleware)
        .concat(activityApi.middleware)
        .concat(transporterApi.middleware)
        .concat(loadApi.middleware)
        .concat(subscriptionApi.middleware)
        .concat(confirmationApi.middleware)
        .concat(readinessApi.middleware)
        .concat(taskApi.middleware)
        .concat(workflowApi.middleware)
        .concat(loadInvoiceApi.middleware)
        .concat(storageInvoiceApi.middleware)
        .concat(mechanicalsApi.middleware)
        .concat(billingApi.middleware)
        .concat(notesApi.middleware)
        .concat(flagsApi.middleware)
        .concat(activityTypeInventoryApi.middleware)
        .concat(activityTypeStepApi.middleware)
        .concat(vendorApi.middleware)
        .concat(routerMiddleware(history))
        .concat(rtkQueryErrorLogger)
        .concat(rolesApi.middleware)
        .concat(securityPhotosApi.middleware)
        .concat(clientAccountApi.middleware)
        .concat(reportApi.middleware)
        .concat(contactTypeApi.middleware)
        .concat(vehicleStatusApi.middleware)
        .concat(reportsApi.middleware)
        .concat(taxRatesApi.middleware)
        .concat(reservationApi.middleware)
        .concat(vehicleAttachmentsApi.middleware)
        .concat(quickBooksAccountMappingApi.middleware)
        .concat(issueTrackerRuleApi.middleware)
        .concat(washProgramApi.middleware)
        .concat(vendorInvoiceApi.middleware)
});

export default store;
